import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Button,
  Card,
  CardHeader,
  Table
} from "reactstrap";
// import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
// import { DateRangePicker } from "react-dates";
// import "react-dates/lib/css/_datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";

export default class PastBookingOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      bookingStartDate: moment().endOf("day"),
      bookingEndDate: moment().endOf("day"),
      grandTotal: 0.0,
      loading: false,
      loadingValue: "Please Wait a moment, loading",
      merchants: null,
      stores: null,
      storeIds: [],
      selectedOrdersText: "Shows Booking Orders"
    };
  }

  componentDidMount() {
    this.getOrders();
  }

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };

  handleBookingEndDateChange = date => {
    this.setState({
      bookingEndDate: date
    });
  };

  getOrders = async bookingDateSelect => {
    let orders = [];

    this.setState({
      orders: [],
      grandTotal: 0.0,
      loadingValue: "Please Wait a moment, loading",
      loading: false
    });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }
    console.log("params", params);
    let requestManager = new RequestManager();

    let date = "",
      query;

    if (this.state.bookingEndDate !== null) {
      date = this.state.bookingEndDate.format("YYYY-MM-DDT");
      date = date + "00:00:00+05:30";
      params.orderBookingDateAt_Gte = date;
    }
    if (this.state.bookingEndDate !== null) {
      date = this.state.bookingEndDate.format("YYYY-MM-DDT");
      date = date + "23:59:59+00:00";
      params.orderBookingDateAt_Lte = date;
    }
    query = "getBookingOrderDetails";

    console.log(params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      query,
      params
    );
    console.log(response);
    if (response.error === null) {
      for (let i = 0; i < response.data.orderHistory.edges.length; i++) {
        orders.push(response.data.orderHistory.edges[i]);
      }
      let grandTotal = 0.0;
      for (let i = 0; i < orders.length; i++) {
        grandTotal = grandTotal + orders[i].node.cart.settlementPrice;
      }
      if (orders.length === 0)
        this.setState({
          orders: orders,
          grandTotal: grandTotal.toFixed(2),
          loadingValue: "No Rows Found",
          loading: false
        });
      else
        this.setState({
          orders: orders,
          grandTotal: grandTotal.toFixed(2),
          loading: true
        });
    }
  };
  getCountOfItems = () => {
    if (this.state.orders) {
      let cartItems =
        this.state.orders && this.state.orders.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };
  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let date = "";
    if (this.state.endDate !== null) {
      date = this.state.bookingEndDate.format("YYYY-MM-DD");
      // date = date+"00:00:00+00:00";
    }
    let csvData = [
      [this.state.pageText],

      ["Grand Total", "Start Date", "End Date"],
      [
        this.state.grandTotal,
        date,
        this.state.bookingEndDate.format("YYYY-MM-DD")
      ],
      [""],
      [""],
      [
        "Order Id",
        "Token",
        "Status",
        "Date/Time",
        "SubTotal(₹)",
        "Discount(₹)",
        "Tax Amount(₹)",
        "Total Amount(₹)",
        "Store"
      ]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt)
          .utcOffset("+05:30")
          .format("MMMM DD YYYY, h:mm a"),
        order.node.cart.subtotal,
        this.getDiscountAmount(order.node.cart.settlementExtra),
        this.getGSTAndCGST(order.node.cart.settlementExtra),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name
      ]);
    });
    return csvData;
  };

  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Row noGutters>
          <Col xs="12">
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row style={{ marginTop: 15 }}>
                    {" "}
                    <p> Orders Booking Date</p>{" "}
                  </Row>
                  <Row>
                    <Col xs="12" sm="12" md="4" lg="4">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        <div style={{ marginLeft: 15 }}>
                          <DatePicker
                            selected={this.state.bookingEndDate}
                            dateFormat="DD/MM/YYYY"
                            maxDate={moment().endOf("day")}
                            onChange={this.handleBookingEndDateChange}
                          />
                        </div>

                        <Button
                          style={{
                            marginLeft: 20,
                            backgroundColor: "#00a9db",
                            color: "white"
                          }}
                          onClick={() => {
                            this.getOrders(true);
                          }}
                        >
                          GetOrdersBooking
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {/* <Row style={{ marginTop: 10 }}>
                    <h5>{this.state.selectedOrdersText}</h5>
                  </Row> */}
                  <Row style={{ margin: 15 }}>
                    <h5>{"Grand Total= " + this.state.grandTotal}</h5>
                    <CSVLink
                      className="btn btn-primary"
                      style={{ marginLeft: 20 }}
                      filename={"OrderSummary.csv"}
                      data={this.getCSVData()}
                    >
                      Export to CSV
                    </CSVLink>
                  </Row>
                </Container>
              </CardHeader>
              <Table responsive>
                <tbody>
                  <tr>
                    <th>Order Id</th>
                    <th>Token</th>
                    <th>Status</th>
                    <th>Date/Time</th>
                    <th>SubTotal</th>
                    <th>DiscountAmount</th>
                    <th>TaxAmount</th>
                    <th>Total Amount</th>
                    <th>Store</th>
                  </tr>
                  {this.state.loading === false ? (
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td style={{ textAlign: "center" }}>
                        {this.state.loadingValue}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ) : (
                    this.state.orders &&
                    this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                          onClick={() => {
                            this.setState({ selectedOrder: order });
                            // this.toggleModal();
                          }}
                        >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td>{order.node.status}</td>
                          <td>
                            {moment(order.node.createdAt)
                              .utcOffset("+05:30")
                              .format("MMMM DD YYYY, h:mm a")}
                          </td>
                          <td>{"₹" + order.node.cart.subtotal}</td>
                          <td>
                            {" "}
                            {"₹" + order.node.cart.settlementExtra &&
                              this.getDiscountAmount(
                                order.node.cart.settlementExtra
                              )}
                          </td>
                          <td>
                            {" "}
                            {"₹" + order.node.cart.settlementExtra &&
                              this.getGSTAndCGST(
                                order.node.cart.settlementExtra
                              )}
                          </td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
  getGSTAndCGST = extraText => {
    let gst_cgst = 0;
    try {
      let extra = JSON.parse(extraText);
      // eslint-disable-next-line
      let offers = extra.offer === null ? [] : extra.offer;
      let charges = extra.charge === null ? [] : extra.charge;

      for (let i = 0; i < charges.length; i++) {
        gst_cgst = gst_cgst + charges[i].amount;
      }
    } catch (e) {
      gst_cgst = 0;
    }
    return gst_cgst;
  };
  getDiscountAmount = extraText => {
    let offersAmount = 0;
    try {
      let extra = JSON.parse(extraText);

      let offers = extra.offer === null ? [] : extra.offer;

      for (let i = 0; i < offers.length; i++) {
        offersAmount = offersAmount + offers[i].amount;
      }
    } catch (e) {
      offersAmount = 0;
    }
    return offersAmount;
  };
}



// WEBPACK FOOTER //
// ./src/pages/PastBookingOrders/PastBookingOrders.js